angular.module('impactx.rfx').controller('RfxEditFreeFormOfferCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'TranslationService',
    'basketItemGroupId',
    'headerId',
    '$mdToast',
    '$context',
    '$securityManager',
    'RFXSupplierService',
    'ToastService',
    'DownloadService',
    '$timeout',
    'FileHelperService',
    '$q',
    'lotId',
    'supplierId',
    'items',
    'groupData',
    'cscId',
    'readOnly',
    'FreeFormDialogService',
    'contracts',
    RfxEditFreeFormOfferCtrl
]);

function RfxEditFreeFormOfferCtrl($scope, dataGen, $mdDialog, TranslationService, basketItemGroupId, headerId, $mdToast,
                               $context, $securityManager, RFXSupplierService, ToastService, DownloadService,
                               $timeout, FileHelperService, $q, lotId, supplierId, items, groupData, cscId, readOnly, FreeFormDialogService,
                               contracts) {
    var self = this;
    var typeComplete = FreeFormDialogService.typeComplete;
    var typeItems = FreeFormDialogService.typeItems;
    $scope.typeComplete = typeComplete;
    $scope.typeItems = typeItems;
    self.freeformOfferLotSelect = FreeFormDialogService.freeformOfferLotSelect;
    $scope.readOnly = readOnly;
    $scope.dataInProgress = {value: false};
    $scope.rfqsId = headerId;
    $scope.lotId = lotId ? Number(lotId) : 0;
    $scope.cscId = cscId ? Number(cscId) : 0;
    $scope.supplierId = supplierId;
    $scope.basketItemGroupId = basketItemGroupId;
    $scope.typeSelected = 0;
    $scope.trns = {};
    //set data to prevent problem with multiple async autocompletes in ng-if
    $scope.data = {};
    var oldSupplierSelection = {};
    var numberOfMaterialGroupMappingsInProgress = 0;
    var uploadInProgress = false;
    $scope.currentlyImportingExcel = false;
    $scope.errorList = [];
    $scope.sumHasChanged = false;
    var supplierNoTimeOut;
    var contractReadOnly = false;
    var lotReadOnly = false;

    self.markSumAsChanged = function (value) {
        $scope.sumHasChanged = value;
    };

    self.setOutletId = function (dataObj) {
        var foundContract = undefined;
        if (contracts) {
            angular.forEach(contracts, function (contract) {
                if (dataObj.cscId === contract.id || dataObj.lotId === contract.lotId) {
                    foundContract = contract;
                }
            });
        }
        if (foundContract && impactX.isDefined(foundContract, "outlet.selected.id")) {
            dataObj.outletId = impactX.isDefined(foundContract, "outlet.selected.id");
        }
    }

    if ($scope.basketItemGroupId === 0) {
        $scope.wizardIndex = 0;
        dataGen.getData($scope, {rfqsId: $scope.rfqsId}, "/rfx/freeformoffer/view").then(function () {
            $scope.initialDataReceived = true;
            addTrns();
            FreeFormDialogService.addWatchSelection($scope, self.forward);
            contractReadOnly = $scope.data.contract.readOnly;
            lotReadOnly = $scope.data.lot.readOnly;
        });
    }
    else {
        $scope.wizardIndex = 2;
        var dataObj = {
            headerId: $scope.rfqsId,
            cscId: $scope.cscId,
            lotId: $scope.lotId,
            supplierOrOutletId: $scope.supplierId,
            readOnly: readOnly
        };
        self.setOutletId(dataObj);

        if ($scope.basketItemGroupId > 0) {
            dataObj.basketItemGroupId = $scope.basketItemGroupId;
        }
        dataGen.getData($scope, dataObj, "/rfx/freeformoffer/items/view").then(function () {
            addTrns();
            if (!readOnly) {
                $scope.data.requestItems = items;
            }
            $scope.data.number = groupData.number;
            $scope.data.name = groupData.name;
            $scope.data.comments = groupData.comments;
            for (var i = 0; i < $scope.data.requestItems.length; i++) {
                $scope.data.requestItems[i].hasValues = true;
            }
            if (!readOnly) {
                $scope.data.requestItems.push(JSON.parse(JSON.stringify($scope.data.templateItem)));
            }
            self.recalculateItemsOffer();
        });
    }

    self.cancel = function () {
        $mdDialog.cancel();
    };

    self.forward = function (selectedType) {
        $scope.wizardIndex = selectedType;
        $scope.dataInProgress.value = true;
        if ($scope.wizardIndex === typeComplete) {
            self.getDataForCompleteOffer();
        }
        if ($scope.wizardIndex === typeItems) {
            self.getDataForItemOffer();
        }
    };

    self.back = function () {
        $scope.wizardIndex = 0;
        if (oldSupplierSelection) {
            $scope.data.supplier.selected = oldSupplierSelection;
        }
        $scope.data.contract.readOnly = contractReadOnly;
        $scope.data.lot.readOnly = lotReadOnly;
        $scope.ignoreWatchOnce = true;
        if (impactX.isDefined($scope, 'data.contract.selected.id') && self.freeformOfferLotSelect) {
            $scope.data.contract.selected = undefined;
        }
    };

    self.getDataForCompleteOffer = function () {
        oldSupplierSelection = $scope.data.supplier.selected;
        var dataObj = {
            headerId: $scope.rfqsId,
            cscId: impactX.isDefined($scope, 'data.contract.selected.id'),
            lotId: $scope.lotId || impactX.isDefined($scope, 'data.lot.selected.id'),
            supplierOrOutletId: $scope.data.supplier.selected && $scope.data.supplier.selected.id ? $scope.data.supplier.selected.id : $scope.supplierId
        };
        self.setOutletId(dataObj);
        var tempScope = {};
        dataGen.getData(tempScope, dataObj, "/rfx/freeformoffer/complete/view").then(function () {
            $scope.dataInProgress.value = false;
            tempScope.data.requestItem.isFreeFormOffer = true;
            $scope.data.requestItem = tempScope.data.requestItem;
            $scope.data.showGross = tempScope.data.showGross;
            $scope.data.supplier = tempScope.data.supplier;
            $scope.data.outlet = tempScope.data.outlet;
            $scope.data.contractData = tempScope.data.contractData;
        });
    };

    self.getDataForItemOffer = function () {
        oldSupplierSelection = $scope.data.supplier.selected;
        var dataObj = {
            headerId: $scope.rfqsId,
            cscId: impactX.isDefined($scope, 'data.contract.selected.id'),
            lotId: $scope.lotId || impactX.isDefined($scope, 'data.lot.selected.id'),
            supplierOrOutletId: $scope.data.supplier.selected && $scope.data.supplier.selected.id ? $scope.data.supplier.selected.id : $scope.supplierId
        };
        self.setOutletId(dataObj);
        var tempScope = {};
        dataGen.getData(tempScope, dataObj, "/rfx/freeformoffer/items/view").then(function () {
            $scope.dataInProgress.value = false;
            $scope.trns.noArticleData = tempScope.trns.noArticleData;
            $scope.trns.uploadInProgress = tempScope.trns.uploadInProgress;
            $scope.trns.downloadTemplate = tempScope.trns.downloadTemplate;
            $scope.trns.uploadTemplate = tempScope.trns.uploadTemplate;
            tempScope.data.templateItem.isFreeFormOffer = true;
            $scope.data.templateItem = tempScope.data.templateItem;
            $scope.data.requestItems = [];
            $scope.$watch(function () {
                return $scope.data.requestItems.length
            }, function () {
                self.checkForErrors();
            });
            var classification = tempScope.data.templateItem.eClassSelection ? tempScope.data.templateItem.eClassSelection.selected : undefined;
            if (tempScope.data.templateItem.eClassSelection && tempScope.data.templateItem.eClassSelection.freeSelection) {
                classification = {id: 0, secondValue: tempScope.data.templateItem.eClassSelection.freeSelection.value}
            }
            self.updateMaterialGroupMapping(classification, $scope.data.templateItem).then(function () {
                $scope.data.requestItems.push(JSON.parse(JSON.stringify($scope.data.templateItem)));
                $scope.data.number = tempScope.data.number;
                $scope.data.name = tempScope.data.name;
                $scope.data.comments = tempScope.data.comments;
                $scope.data.showGross = tempScope.data.showGross;
                $scope.data.supplier = tempScope.data.supplier;
                $scope.data.outlet = tempScope.data.outlet;
                $scope.data.contractData = tempScope.data.contractData;
                $scope.data.contract = tempScope.data.contract;
            });
        });
    };

    self.closeFunction = function () {
        if ($scope.wizardIndex === 2) {
            if ($scope.data.requestItems) {
                var firstItem = $scope.data.requestItems[0];
                firstItem.basketItemGroupData = {};
                firstItem.basketItemGroupData.name = $scope.data.name;
                firstItem.basketItemGroupData.number = $scope.data.number;
                firstItem.basketItemGroupData.comments = $scope.data.comments
                // remove last item since it is always empty
                $scope.data.requestItems.splice($scope.data.requestItems.length-1, 1);

                angular.forEach($scope.data.requestItems, function (item) {
                    item.basketItemGroupId = $scope.basketItemGroupId || 0;
                    item.basketItemGroupNumber = $scope.data.number.value
                    item.lot = impactX.isDefined($scope, 'data.lot.selected');
                    item.csc = impactX.isDefined($scope, 'data.contract.selected');
                });
            }
        }
        else if ($scope.wizardIndex === 1) {
            $scope.data.requestItem.lot = impactX.isDefined($scope, 'data.lot.selected');
            $scope.data.requestItem.csc = impactX.isDefined($scope, 'data.contract.selected');
        }
        $scope.data.completeOffer = $scope.wizardIndex === 1;
        $mdDialog.hide($scope.data);
    };

    self.updateGUI = function (index, markSumAsChanged) {
        if (index !== undefined) {
            var requestItem = $scope.data.requestItems[index];
            if (!requestItem.hasValues) {
                requestItem.hasValues = true;
                $scope.data.requestItems.push(JSON.parse(JSON.stringify($scope.data.templateItem)));
            }
        }
        if ($scope.wizardIndex === typeComplete) {
            self.recalculateCompleteOffer();
        }
        else {
            if (markSumAsChanged) {
                self.markSumAsChanged(true);
            }
        }
    };

    self.updateGUICurrency = function (index, selectedCurrency) {
        if (index !== undefined) {
            var requestItem = $scope.data.requestItems[index];
            if (!requestItem.hasValues) {
                requestItem.hasValues = true;
                $scope.data.requestItems.push(JSON.parse(JSON.stringify($scope.data.templateItem)));
            }
        }
        if (index > 0) {
            $scope.data.requestItems[index].price.currency.selected = selectedCurrency;
        }
        else {
            $scope.data.requestItem.price.currency.selected = selectedCurrency;
        }

        if ($scope.wizardIndex === typeComplete) {
            self.recalculateCompleteOffer();
        }
        else {
            self.markSumAsChanged(true);
        }
    };

    self.recalculateCompleteOffer = function () {
        var tempScope = {};
        RFXSupplierService.cacheItemComments($scope.data.requestItem);
        var copiedItem = JSON.parse(JSON.stringify($scope.data.requestItem));
        copiedItem.comments = null;
        dataGen.postAsForm(tempScope, {items: [copiedItem]}, "/rfx/freeformoffer/summary").then(function () {
            $scope.summary = tempScope.data;
            RFXSupplierService.restoreItemComments($scope.data.requestItem);
        });
    };

    self.recalculateItemsOffer = function () {
        var tempScope = {};
        RFXSupplierService.cacheItemListComments($scope.data.requestItems);
        dataGen.postAsForm(tempScope, {items: $scope.data.requestItems}, "/rfx/freeformoffer/summary").then(function () {
            $scope.summary = tempScope.data;
            RFXSupplierService.restoreItemListComments($scope.data.requestItems);
            self.markSumAsChanged(false);
        });
    };

    self.removeLine = function (index) {
        $scope.data.requestItems.splice(index, 1);
        self.markSumAsChanged(true);
    };

    self.downloadTemplate = function () {
        DownloadService.openDownloadPost('/rfx/freeformoffer/items/template')
    };

    self.uploadTemplate = function () {
        angular.element(document.querySelector('#uploadTemplate')).on('change', self.handleFileSelect);
        $timeout(function () {
            angular.element(document.querySelector('#uploadTemplate')).click();
        });
    };

    self.handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        $(this).val("");
        self.handleFile(evt, file);
    };

    self.handleFile = function (evt, file) {
        if (file) {
            if (!FileHelperService.checkAllowedFileWithError(file.name)) {
                return;
            }
            uploadInProgress = true;
            $scope.$evalAsync(function () {
                self.addAttachmentStream(file);
            });
        }
    };

    self.handlePositionImportData = function (data) {
        if (data.data && data.data.itemList) {
            $scope.data.requestItems.splice($scope.data.requestItems.length - 1, 1);
            for (var i = 0; i < data.data.itemList.length; i++) {
                var requestItem = data.data.itemList[i];
                if (!requestItem.hasValues) {
                    requestItem.hasValues = true;
                }
                numberOfMaterialGroupMappingsInProgress++;
                var classification = requestItem.eClassSelection ? requestItem.eClassSelection.selected : undefined;
                if (requestItem.eClassSelection && requestItem.eClassSelection.freeSelection) {
                    classification = {id: 0, secondValue: requestItem.eClassSelection.freeSelection.value}
                }
                self.updateMaterialGroupMapping(classification, requestItem).then(function () {
                    numberOfMaterialGroupMappingsInProgress--;
                });
                $scope.data.requestItems.push(requestItem);
            }
            $scope.data.requestItems.push(JSON.parse(JSON.stringify($scope.data.templateItem)));
            self.recalculateItemsOffer();
        }
        uploadInProgress = false;
    };

    $scope.$watch(function () {
        return uploadInProgress
    }, function (newVal) {
        if (!newVal && numberOfMaterialGroupMappingsInProgress <= 0) {
            $scope.currentlyImportingExcel = false;
        }
        if (newVal) {
            $scope.currentlyImportingExcel = true;
        }
        self.checkForErrors();
    });

    $scope.$watch(function () {
        return numberOfMaterialGroupMappingsInProgress
    }, function (newVal, oldValue) {
        if (newVal === 0 && !uploadInProgress) {
            $scope.currentlyImportingExcel = false;
        }
        self.checkForErrors();
    });

    self.addAttachmentStream = function (file) {
        var data = {
            file: file,
            rfqsId: $scope.rfqsId,
            cscId: $scope.data.contract.selected.id
        };

        dataGen.uploadFile(data, '/rfx/freeformoffer/items/import', true).then(function (data) {
            self.handlePositionImportData(data);
        }, function (data) {
            self.handlePositionImportData(data);
        });
    };

    self.updateMaterialGroupMapping = function (selected, requestItem) {
        var defer;
        if (!requestItem) {
            requestItem = $scope.data.requestItem;
        }
        if (requestItem.eClassMaterialGroupMapping) {
            if (!selected) {
                requestItem.eClassMaterialGroupMapping.selected = null;
                defer = $q.defer();
                defer.resolve();
                return defer.promise;
            }
            else {
                var tempScope = {};
                return dataGen.getData(tempScope, {
                    eClass: selected.secondValue,
                    sapConfigId: requestItem.sapConfigId
                }, "/rfx/freeform/materialgroupmappingforeclass").then(function () {
                    requestItem.eClassMaterialGroupMapping.selected = tempScope.data.newMapping;
                });
            }
        }
        else {
            defer = $q.defer();
            defer.resolve();
            return defer.promise;
        }
    };

    self.updateMaterialGroupMappingAndGUI = function (index, requestItem, selected) {
        self.updateMaterialGroupMapping(selected, requestItem);
        self.updateGUI(index);
    };

    self.checkForErrors = function () {
        $scope.errorList.length = 0;
        if ($scope.wizardIndex === 2) {
            if ($scope.data.requestItems && $scope.data.requestItems.length === 1) {
                $scope.errorList.push($scope.trns.noArticleData);
            }
            if ($scope.currentlyImportingExcel) {
                $scope.errorList.push($scope.trns.uploadInProgress);
            }
        }
    };

    self.getEClassFromSupplierNoForItems = function (index) {
        if (supplierNoTimeOut) {
            $timeout.cancel(supplierNoTimeOut);
        }
        supplierNoTimeOut = $timeout(function () {
            if ($scope.data.requestItems[index].supplierNo.value && $scope.data.requestItems[index].eClassSelection) {
                dataGen.getData({}, {
                        supplierNo: $scope.data.requestItems[index].supplierNo.value,
                        cscId: $scope.data.contract.selected.id
                    },
                    "/rfx/freeformoffer/items/eclassfromproduct").then(function (data) {
                    if (data.data) {
                        $scope.data.requestItems[index].eClassSelection.selected = data.data;
                        $scope.data.requestItems[index].eClassSetFromProduct = true;
                    }
                    $scope.data.requestItems[index].eClassRequestInProgress = false;
                });
            }
            else {
                $scope.data.requestItems[index].eClassRequestInProgress = false;
            }

            supplierNoTimeOut = null;
        }, 500);
        $scope.data.requestItems[index].eClassSetFromProduct = false;
        $scope.data.requestItems[index].eClassRequestInProgress = true;
        self.updateGUI(index);
    };

    function addTrns() {
        $scope.trns.save = TranslationService.get("accept");
        $scope.trns.abort = TranslationService.get("abort");
        $scope.trns.back = TranslationService.get("back");
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');
        $scope.trns.zeroNotAllowed = TranslationService.get("zeroNotAllowed");
        $scope.trns.noDigitsAllowed = TranslationService.get("noDigitsAllowed");
        $scope.trns.updateSum = TranslationService.get("updateSum");
    }

    $scope.initialized = true;

    self.showOption = function (type) {
        return FreeFormDialogService.showOption($scope, type);
    }
}
